/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { NormativeDocumentPermissionIncludeFilterItems } from './normativeDocumentPermissionIncludeFilterItems';
import { NormativeDocumentPermissionScopeFilter } from './normativeDocumentPermissionScopeFilter';


export interface NormativeDocumentPermissionIncludeFilterInner { 
    relation?: NormativeDocumentPermissionIncludeFilterInner.RelationEnum;
    scope?: NormativeDocumentPermissionScopeFilter;
}
export namespace NormativeDocumentPermissionIncludeFilterInner {
    export type RelationEnum = 'document' | 'user' | 'role';
    export const RelationEnum = {
        Document: 'document' as RelationEnum,
        User: 'user' as RelationEnum,
        Role: 'role' as RelationEnum
    };
}


